// extracted by mini-css-extract-plugin
export default {"root":"FormFieldLabel_root__hnBSA","root_required":"FormFieldLabel_root_required__heuOQ"};